import PrivilegiosEnum from "@/core/utils/PrivilegioEnum"
import ModuloEnum from "@/core/utils/ModuloEnum"

const componentRouterView = {
    render(c) {
        return c("router-view");
    },
};


const routes = {
    path: "/gestao-financeira",
    component: componentRouterView,
    meta: {
        moduleName: "Gestão Financeira",
        icon: "wallet",
        modulo: ModuloEnum.NAO_NECESSITA_VERIFICACAO,
        sistema: 2, 
    },
    children: [
        {
            path: "orcamento-previo",
            name: "orcamentoPrevio",
            meta: { description: "Orçamento Prévio", menu: { name: "Orçamento Prévio", permissao: PrivilegiosEnum.GESTAO_FINANCEIRA_ACESSAR } },
            component: () => import("./orcamento-previo/ConsultarOrcamento.vue"),
        },
    ],
};

export default routes;
